// Requires at least one checked checkbox in the group; native form validation blocks submit and the group shows its inline error.
class SRequiredChoice extends HTMLElement {
  connectedCallback() {
    this.boxes = [...this.querySelectorAll('input[type="checkbox"]')];
    this.error = this.querySelector('[data-choice-error]');
    if (!this.boxes.length) return;
    this.addEventListener('change', this.#sync);
    this.boxes[0].addEventListener('invalid', this.#onInvalid);
    this.#sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#sync);
    this.boxes?.[0]?.removeEventListener('invalid', this.#onInvalid);
  }

  #sync = () => {
    const anyChecked = this.boxes.some((box) => box.checked);
    this.boxes[0].setCustomValidity(anyChecked ? '' : this.dataset.message || '');
    if (anyChecked) this.#showError(false);
  };

  #onInvalid = () => {
    this.#showError(true);
  };

  #showError(show) {
    this.toggleAttribute('data-invalid', show);
    if (this.error) this.error.hidden = !show;
  }
}

if (!customElements.get('s-required-choice')) customElements.define('s-required-choice', SRequiredChoice);
